import React from "react";
import getColorsHook from "../getColorsHook";
import styles from "./style.module.css";

const Button = ({ selected, name, onClick, children, style }) => {
  const [colors] = getColorsHook();

  const btnStyle = {
    ...style,
    color: colors.text1,
    background: colors.bgContrast,
  };

  if (selected) btnStyle.background = colors.bg2;

  return (
    <button className={styles.btn} style={btnStyle} onClick={onClick}>
      {children}
    </button>
  );
};

export default Button;
